import MicroModal from 'micromodal';
import { LuminousGallery } from 'luminous-lightbox';
import Swiper from 'swiper/bundle';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function mobileMenu() {
  const navigationMenu = document.getElementById('navigation-menu');
  if (!navigationMenu) return;

  const navigationMenuToggle = document.getElementById(
    'navigation-menu-toggle'
  );
  const navigationMenuList = navigationMenu.querySelectorAll('.menu-item');

  navigationMenuToggle.addEventListener('click', function (e) {
    if (document.body.dataset.navigation === 'open') {
      document.body.dataset.navigation = 'close';
    } else {
      document.body.dataset.navigation = 'open';
    }
  });

  navigationMenuList.forEach(function (el) {
    el.querySelector('a').addEventListener('click', function (e) {
      document.body.dataset.navigation = 'close';
    });
  });
}

function add_campaign_parts() {
  if ('content' in document.createElement('template')) {
    const common_campaign_section = document.querySelectorAll(
      'aside.common-campaign-section'
    );
    
    const template = document.querySelector('#common-campaign-contents');
    var clone;

    common_campaign_section.forEach(function (el) {
      // console.debug(el);
      clone = template.content.cloneNode(true);
      el.appendChild(clone);
    });
  }
}

function swiperTabController(swiper) {
  const tabWrappers = document.querySelectorAll('.machine-tab');
  if (!tabWrappers) return;

  tabWrappers.forEach(function (el) {
    const tabs = el.querySelectorAll('input');
    tabs.forEach(function (tab, i) {
      tab.addEventListener('change', function (e) {
        swiper.slideTo(i);
      });
    });
  });
}

function swiperChangeTab(callback) {
  const tabWrappers = document.querySelectorAll('.machine-tab');
  if (!tabWrappers) return;

  const currendIndex = callback.activeIndex;

  tabWrappers.forEach(function (el) {
    const tabs = el.querySelectorAll('input');
    tabs.forEach(function (tab, i) {
      // console.debug(tab);
      // console.debug(i);
      // el.checked = false;
      if (i === currendIndex) {
        tab.checked = true;
      }
    });
  });
}

function swiperChangeCaption(callback) {
  var timerId;

  const caption = callback.el.nextElementSibling;
  if (!caption) return;

  caption.classList.add('hide');

  const currentSlidId = callback.activeIndex;
  // console.debug(currentSlidId);

  const currentSlideNum = currentSlidId + 1;
  const totalSlideNum = callback.slides.length;
  const currentCaption = callback.slides[currentSlidId].dataset.swiperCaption;

  timerId = setTimeout(function () {
    // console.debug(currentSlideNum + '/' + totalSlideNum);
    // console.debug(currentCaption);

    caption.querySelector('.number').textContent =
      currentSlideNum + '/' + totalSlideNum;
    caption.querySelector('.label').textContent = currentCaption;

    caption.classList.remove('hide');
  }, 300);

  // clearTimeout(timerId);
}

function tabController(){
  const tabWrappers = document.querySelectorAll('.content-tab-wrapper');

  tabWrappers.forEach(function (wrapper) {
    const tabs = wrapper.querySelectorAll('input[type="radio"]');
    const contents = wrapper.querySelectorAll('.content-tab-section');
    contents.forEach(function (content, i) {
      if( i > 0 ){
        content.style.display = 'none';
      }
    });

    tabs.forEach(function (tab, index) {
      tab.addEventListener('change', function () {
        contents.forEach(function (content, i) {
          content.style.display = i === index ? 'block' : 'none';
        });

        // #top-price の位置にスクロール
        // if (topPrice) {
        //   topPrice.scrollIntoView({ behavior: 'smooth' });
        // }

        // #top-price の位置に移動する際、内包する .section-title の高さを考慮してスクロール
        const topPrice = document.getElementById('top-price');
        const sectionTitle = topPrice.querySelector('.section-title');
        const sectionTitleHeight = sectionTitle ? sectionTitle.offsetHeight : 0;

        // topPrice の padding-top の値を取得
        const topPricePaddingTop = parseFloat(getComputedStyle(topPrice).paddingTop);

        window.scrollTo({
          top: topPrice.offsetTop + sectionTitleHeight + topPricePaddingTop,
          behavior: 'smooth'
        });

      });
    });

  });
}

function init() {

  tabController();
  mobileMenu();
  add_campaign_parts();

  const luminousInit = new LuminousGallery(
    document.querySelectorAll('a.luminous')
  );

  // in-view 属性を持つすべての要素を取得
  const elements = document.querySelectorAll('[data-in-view]');

  elements.forEach((el) => {
    ScrollTrigger.create({
      trigger: el, // 対象要素
      start: 'top 80%', // ビューポートの80%位置に来たとき
      end: 'top 20%', // ビューポートの20%位置を出るとき
      onEnter: () => el.classList.add('view'), // 画面内に入ったとき
      // onLeave: () => el.classList.remove("view"), // 画面外に出たとき
      // onEnterBack: () => el.classList.add("view"), // スクロールバックで再度入ったとき
      // onLeaveBack: () => el.classList.remove("view"), // スクロールバックで再度外れたとき
      markers: false, // デバッグ用のマーカーを無効に（必要ならtrueに）
    });
  });

  MicroModal.init({
    disableScroll: true,
  });

  const featureSwiper = new Swiper('.feature-swiper', {
    speed: 400,
    spaceBetween: 28,
    slidesPerView: 1.3,
    centeredSlides: true,
    loop: true,
    breakpoints: {
      480: {
        spaceBetween: 40,
        slidesPerView: 3,
        centeredSlides: false,
        loop: false,
      },
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const aboutSwiper = new Swiper('.about-swiper', {
    speed: 1000,
    effect: 'fade',
    crossFade: true,
    // loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    on: {
      init: swiperChangeCaption,
      activeIndexChange: swiperChangeCaption,
    },
  });

  const machineSwiper = new Swiper('.machine-swiper', {
    speed: 400,
    spaceBetween: 20,
    slidesPerView: 1.1,
    centeredSlides: true,
    // 高さをコンテンツに合わせる
    autoHeight: true,
    // loop: true,
    breakpoints: {
      480: {
        spaceBetween: 80,
        slidesPerView: 1.3,
        // loop: false
      },
      1441: {
        spaceBetween: 100,
        slidesPerView: 1.5,
        // loop: false
      },
    },
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    //   pauseOnMouseEnter: true,
    // },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: swiperTabController,
      activeIndexChange: swiperChangeTab,
    },
  });

  // swiperTabController(machineSwiper)

  const golfparterSwiper = new Swiper('.golfparter-swiper', {
    speed: 400,
    spaceBetween: 28,
    slidesPerView: 1.3,
    centeredSlides: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      480: {
        spaceBetween: 40,
        slidesPerView: 3,
        centeredSlides: false,
        loop: false,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

document.addEventListener('DOMContentLoaded', init);

var startPos = 0,
  winScrollTop = window.scrollY;
window.addEventListener('scroll', function (e) {
  winScrollTop = window.pageYOffset;
  winHeight = window.innerHeight;

  if (winScrollTop > 1) {
    document.body.dataset.scroll = 'scrolled';
  } else {
    document.body.dataset.scroll = 'unscroll';
  }

  if (startPos < winHeight * 1.5 || winScrollTop <= 0) {
    document.body.dataset.view = 'first';
  } else {
    document.body.dataset.view = 'second';
  }
  startPos = winScrollTop;
  return false;
});
